module.exports = __webpack_public_path__ + "static/biobelle-logo.d28f0ad3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/testimonials/biobelle-logo.png
// module id = 1515
// module chunks = 35783957827783